(function ($) {

    $(document).ready(function () {

        $('.JS--video-popup').magnificPopup({
            type: 'inline',
            closeOnBgClick: true,
            preloader: false,
            modal: false
        });

        $(document).on('click', '.JS--close-video-popup', function (e) {
            e.preventDefault();
            pauseVideo();
            $.magnificPopup.close();
        });

    });


})(jQuery);



var triggerVideoPopup = document.getElementById('call-popup');
var videoPopup = document.getElementById('video-popup');

if (typeof (triggerVideoPopup) !== 'undefined' && triggerVideoPopup != null) {
    triggerVideoPopup.addEventListener('click', function () {
        videojs(videoPopup).play();
        videojs(videoPopup).options.controls = true;
    });
}



function pauseVideo() {
    videojs(videoPopup).pause();
}

